@if (totalItemsInDb > itemsPerPage) {
  <div data-cy="pagination" class="pagination">
    <div class="pagination-btns">
      <div class="mr-11 max-sm:mr-2 aside-page">
        <ul class="quickpages quickpages-aside">
          <li [ngClass]="{ disabled: pagination.current === 1 }">
            <sdc-button
              [styleClass]="['border-0']"
              className="!bg-transparent !shadow-none !p-0 !w-full !min-w-0 !h-full"
              data-cy="first-page-button"
              theme="theme-sdc"
              type="button"
              variant="link"
              [disabled]="pagination.current === 1"
              (onClick)="goto(1)">
              1
            </sdc-button>
          </li>
        </ul>
      </div>
      <div class="pagination-btns__middle">
        <ul class="quickpages">
          <li [ngClass]="{ disabled: pagination.current === 1 }">
            <sdc-button
              className="pagination-nav-arrow !bg-transparent disabled:opacity-30 !p-0 !w-full !min-w-0 !h-full disabled:hover:transform-none hover:scale-95 transition-transform"
              data-cy="prev-page-button"
              theme="theme-sdc"
              type="button"
              variant="link"
              aria-label="Previous page"
              [disabled]="pagination.current === 1"
              (onClick)="goto(pagination.previous)">
              <span class="pagination-nav-arrow-icon" aria-hidden="true">
                <sdc-svg-icon
                  [iconFolder]="'assets/img'"
                  [name]="'arrow-left-black-icon'"
                  [strokeWidth]="0.7"
                  className="pagination-nav-arrow-svg" />
              </span>
            </sdc-button>
          </li>
          @for (i of pagination.quickpages.previous; track i) {
            <li
              class="pagination-extra-page"
              [ngClass]="{
                active: i === pagination.current,
                disabled: pagination.last === pagination.current,
              }">
              <sdc-button
                [styleClass]="['border-0']"
                className="!bg-transparent !shadow-none !p-0 !w-full !min-w-0 !h-full"
                theme="theme-sdc"
                type="button"
                variant="link"
                (onClick)="goto(i)">
                {{ i }}
              </sdc-button>
            </li>
          }
          <li class="current">
            <sdc-button
              [styleClass]="['border-0']"
              className="!bg-transparent !shadow-none !p-0 !w-full !min-w-0 !h-full"
              theme="theme-sdc"
              type="button"
              variant="link"
              [disabled]="true">
              {{ pagination.current }}
            </sdc-button>
          </li>
          @for (i of pagination.quickpages.next; track i) {
            <li
              class="pagination-extra-page"
              [ngClass]="{
                active: i === pagination.current,
                disabled: pagination.last === pagination.current,
              }">
              <sdc-button
                [styleClass]="['border-0']"
                className="!bg-transparent !shadow-none !p-0 !w-full !min-w-0 !h-full"
                theme="theme-sdc"
                type="button"
                variant="link"
                (onClick)="goto(i)">
                {{ i }}
              </sdc-button>
            </li>
          }

          <li [ngClass]="{ disabled: pagination.last === pagination.current }">
            <sdc-button
              className="pagination-nav-arrow !bg-transparent disabled:opacity-30 !p-0 !w-full !min-w-0 !h-full disabled:hover:transform-none hover:scale-95 transition-transform"
              data-cy="next-page-button"
              theme="theme-sdc"
              type="button"
              variant="link"
              aria-label="Next page"
              [disabled]="pagination.last === pagination.current"
              (onClick)="goto(pagination.next)">
              <span class="pagination-nav-arrow-icon" aria-hidden="true">
                <sdc-svg-icon
                  [iconFolder]="'assets/img'"
                  [name]="'arrow-right-black-icon'"
                  [strokeWidth]="0.7"
                  className="pagination-nav-arrow-svg" />
              </span>
            </sdc-button>
          </li>
        </ul>
      </div>
      <div class="ml-11 max-sm:ml-2 aside-page last">
        <ul class="quickpages quickpages-aside">
          <li [ngClass]="{ disabled: pagination.last === pagination.current }">
            <sdc-button
              [styleClass]="['border-0']"
              className="!bg-transparent !shadow-none !p-0 !w-full !min-w-0 !h-full"
              data-cy="last-page-button"
              theme="theme-sdc"
              type="button"
              variant="link"
              [disabled]="pagination.last === pagination.current"
              (onClick)="goto(pagination.last)">
              {{ pagination.last }}
            </sdc-button>
          </li>
        </ul>
      </div>
    </div>
  </div>
}
